import {GlobalErrorAllgemein} from "../components/GlobalErrorAllgemein.tsx";

export const MainPage = () => {
	return <GlobalErrorAllgemein />
}
